import { map, share } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { SettingsService } from '../settings/settings.service';

interface IHttpOptions {
    params?: HttpParams | { [param: string]: string | string[] };
    headers?: HttpHeaders | { [header: string]: string | string[] };
    observe?: 'body';
    responseType?: 'json';
    reportProgress?: boolean;
    withCredentials?: boolean;
}

export class HttpService {

    // Pipe para o observável das requisições
    public pipe = map((response: any) => response);

    /**
     * Serviço geral para requisições HTTP
     *
     * @param  {string} baseUri
     * @param  {HttpClient} http
     */
    constructor(
        private backendUriKey: string,
        private http: HttpClient,
        private settingsService: SettingsService,
    ) {}

    /**
     * Realiza requisições HTTP GET para uma url
     *
     * @param  {string} route
     * @param  {IHttpOptions} options?
     */
    public get = <T = any>(route: string, options?: IHttpOptions) => this.http
        .get(`${this.baseUri}${route}`, options)
        .pipe<T>(this.pipe)

    /** 
     * Realiza requisições HTTP GET ao resource server esperando como resposta um blob
     *
     *  @param url endereço HTTP a ser requisitado
    **/
    public getFile = <T = any>(route: string, options?: IHttpOptions) => this.http
        .get(`${this.baseUri}${route}`, { responseType: 'blob' })
        .pipe(share())

    /**
     * Realiza requisições HTTP PUT para uma url
     *
     * @param  {string} route
     * @param  {any} body
     * @param  {IHttpOptions} options?
     */
    public put = <T = any>(route: string, body: any, options?: IHttpOptions) => this.http
        .put(`${this.baseUri}${route}`, body, options)
        .pipe<T>(this.pipe)

    /**
     * Realiza requisições HTTP POST para uma url
     *
     * @param  {string} route
     * @param  {any} body
     * @param  {IHttpOptions} options?
     */
    public post = <T = any>(route: string, body: any, options?: IHttpOptions) => this.http
        .post(`${this.baseUri}${route}`, body, options)
        .pipe<T>(this.pipe)

    /**
     * Realiza requisições HTTP PATCH para uma url
     *
     * @param  {string} route
     * @param  {any} body
     * @param  {IHttpOptions} options?
     */
    public patch = <T = any>(route: string, body: any, options?: IHttpOptions) => this.http
        .patch(`${this.baseUri}${route}`, body, options)
        .pipe<T>(this.pipe)

    /**
     * Realiza requisições HTTP DELETE para uma url
     *
     * @param  {string} route
     * @param  {IHttpOptions} options?
     */
    public delete = <T = any>(route: string, options?: IHttpOptions) => this.http
        .delete(`${this.baseUri}${route}`, options)
        .pipe<T>(this.pipe)

    /**
     * Getter que retorna a URI base do serviço de backend definido com base em sua key
     */
    private get baseUri() {
        return this.settingsService.getConfigurationKeyValue('backend')[this.backendUriKey];
    }
}
